import React from 'react';
import { Link } from 'react-router-dom';
import ProductList from './ProductList';
import styles from './HomePage.module.css';

const HomePage: React.FC = () => {
  return (
    <div className={styles.homePage}>
      {/* Hero Section */}
      <section className={styles.heroSection}>
        <div className={styles.heroContent}>
          <div className={styles.heroText}>
            <h1 className={styles.heroTitle}>
              Welcome to Appelt-Bonfire Store
            </h1>
            <p className={styles.heroSubtitle}>
              Discover our unique collection of made-to-order products, crafted
              with care and attention to detail.
            </p>
            <div className={styles.heroButtons}>
              <Link to="/products" className={styles.shopNowButton}>
                Shop Now
              </Link>
              <Link to="/contact" className={styles.learnMoreButton}>
                Learn More
              </Link>
            </div>
          </div>
          <div className={styles.heroImage}>
            <img src="/appelt.jpeg" alt="Appelt-Bonfire Store" />
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className={styles.featuresSection}>
        <div className={styles.featuresContainer}>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
            </div>
            <h3 className={styles.featureTitle}>Made to Order</h3>
            <p className={styles.featureText}>
              Each product is crafted specifically for you after the shop
              closes, ensuring quality and reducing waste.
            </p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            </div>
            <h3 className={styles.featureTitle}>Fast Production</h3>
            <p className={styles.featureText}>
              Production begins immediately after orders close, with delivery in
              approximately 3-4 weeks.
            </p>
          </div>
          <div className={styles.featureCard}>
            <div className={styles.featureIcon}>
              <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
                />
              </svg>
            </div>
            <h3 className={styles.featureTitle}>Quality Craftsmanship</h3>
            <p className={styles.featureText}>
              Every item is carefully crafted with premium materials and
              attention to detail.
            </p>
          </div>
        </div>
      </section>

      {/* Products Preview Section */}
      <section className={styles.productsSection}>
        <div className={styles.productsContainer}>
          <div className={styles.productsHeader}>
            <h2 className={styles.productsTitle}>Featured Products</h2>
            <p className={styles.productsSubtitle}>
              Explore our collection of unique, made-to-order items
            </p>
            <Link to="/products" className={styles.viewAllButton}>
              View All Products
            </Link>
          </div>
          <div className={styles.productsPreview}>
            <ProductList />
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className={styles.ctaSection}>
        <div className={styles.ctaContainer}>
          <h2 className={styles.ctaTitle}>Ready to Shop?</h2>
          <p className={styles.ctaText}>
            Browse our collection and place your order before the shop closes.
          </p>
          <Link to="/products" className={styles.ctaButton}>
            Start Shopping
          </Link>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
